module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"185","matomoUrl":"https://stats.goeast.ch/","siteUrl":"https://www.evang-pflegeheime.ch"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
